module.exports = "/_next/static/images/suv-9b1985e3dd2628e6e7091793d479968a.jpg";